import React from 'react';
interface CircularProgressProps {
  percentage: number;
  size?: number;
  strokeWidth?: number;
  color?: string;
}
const CircularProgress: React.FC<CircularProgressProps> = ({
  percentage,
  size = 80,
  strokeWidth = 8,
  color = '#4CAF50'
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const dash = percentage * circumference / 100;
  return <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} data-id="element-17">
      <circle className="text-gray-200" strokeWidth={strokeWidth} stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-18" />
      <circle className="transition-all duration-300 ease-in-out" strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={circumference - dash} strokeLinecap="round" stroke={color} fill="transparent" r={radius} cx={size / 2} cy={size / 2} transform={`rotate(-90 ${size / 2} ${size / 2})`} data-id="element-19" />
      <text x="50%" y="50%" dy=".3em" textAnchor="middle" className="font-semibold text-sm" fill="#333" data-id="element-20">
        {`${percentage.toFixed(1)}%`}
      </text>
    </svg>;
};
export default CircularProgress;